import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { Layout } from './components/Layout';

const HomePage          = lazy(() => import('./pages/HomePage'));
const LeaderboardPage   = lazy(() => import('./pages/LeaderboardPage'));
const ModelDetailPage   = lazy(() => import('./pages/ModelDetailPage'));
const DilemmasPage      = lazy(() => import('./pages/DilemmasPage'));
const DilemmaDetailPage = lazy(() => import('./pages/DilemmaDetailPage'));
const ResponseDetailPage = lazy(() => import('./pages/ResponseDetailPage'));
const ComparePage       = lazy(() => import('./pages/ComparePage'));
const VisualizationPage = lazy(() => import('./pages/VisualizationPage'));
const HeatmapPage       = lazy(() => import('./pages/HeatmapPage'));
const ConsultPage       = lazy(() => import('./pages/ConsultPage'));
const SponsorsPage      = lazy(() => import('./pages/SponsorsPage'));
const WhitepaperPage    = lazy(() => import('./pages/WhitepaperPage'));
const FaqPage           = lazy(() => import('./pages/FaqPage'));
const PrivacyPage       = lazy(() => import('./pages/PrivacyPage'));
const AdminPage         = lazy(() => import('./pages/AdminPage'));
const OutliersPage      = lazy(() => import('./pages/OutliersPage'));
const NotFoundPage      = lazy(() => import('./pages/NotFoundPage'));

export function App() {
  return (
    <Layout>
      <Suspense fallback={<LoadingShell />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/leaderboard" element={<LeaderboardPage />} />
          <Route path="/models/*" element={<ModelDetailPage />} />
          <Route path="/dilemmas" element={<DilemmasPage />} />
          <Route path="/dilemmas/:id" element={<DilemmaDetailPage />} />
          <Route path="/responses/:id" element={<ResponseDetailPage />} />
          <Route path="/compare" element={<ComparePage />} />
          <Route path="/visualizations" element={<VisualizationPage />} />
          <Route path="/heatmap" element={<HeatmapPage />} />
          <Route path="/consult" element={<ConsultPage />} />
          <Route path="/sponsors" element={<SponsorsPage />} />
          <Route path="/whitepaper" element={<WhitepaperPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/outliers" element={<OutliersPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </Layout>
  );
}

function LoadingShell() {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
      <CircularProgress />
    </Box>
  );
}
